const yearFilter = document.querySelector('select[name="year"]')
const typeFilter = document.querySelector('select[name="report-type"]')

const years = document.querySelectorAll('.reports .year')
const reports = document.querySelectorAll('.reports .report')

yearFilter?.addEventListener('change', () => {
	if (yearFilter.value == 'all') {
		years.forEach(year => {
			year.classList.remove('hide')
		})
	} else {
		years.forEach(year => {
			if (year.dataset.year != yearFilter.value) {
				year.classList.add('hide')
			} else {
				year.classList.remove('hide')
			}
		})
	}
})

typeFilter?.addEventListener('change', () => {
	if (typeFilter.value == 'all') {
		reports.forEach(report => {
			report.classList.remove('hide')
		})
	} else {
		reports.forEach(report => {
			if (report.dataset.type != typeFilter.value) {
				report.classList.add('hide')
			} else {
				report.classList.remove('hide')
			}
		})
	}
})
